
export const formatLargeNumber = (value, decimals = 2) => {
  if (!value || value < 1000) return value.toString();
  return `${(value / 1000).toFixed(decimals)}K`;
};

export const formatPercentage = (value, decimals = 2) => {
  if (value === null || value === undefined) return null;
  return `${value.toFixed(decimals)}%`;
};

export const formatCurrency = (value, currency = '$', decimals = 2) => {
  if (!value) return `${currency}0`;
  return `${currency}${value.toFixed(decimals)}`;
};

export const formatNumber = (value, decimals = 0) => {
  if (value === null || value === undefined) return '0';
  return Number(value).toFixed(decimals);
};

export const formatNumberWithCommas = (value, decimals = 2) => {
  if (value === null || value === undefined) return '-';
  const num = Number(value);
  if (isNaN(num)) return '-';
  return num.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
};

export const getTooltipInfo = (rawValue, formattedValue, formatFunction) => {
  if (!rawValue || rawValue < 1000) return { isRounded: false, actualValue: null };
  
  if (formatFunction === formatLargeNumber) {
    const actualValue = formatNumberWithCommas(rawValue, 0);
    const isRounded = formattedValue !== actualValue;
    return { isRounded, actualValue: isRounded ? actualValue : null };
  }
  
  return { isRounded: false, actualValue: null };
}; 